module.exports = __webpack_public_path__ + "static/media/TaylorWallace.65863fe0.jpg";